import React from 'react';
import WärmePNG from '../assets/Prozess.png';

const Wärmeplanung: React.FC = () => (
  <section>
    <div className="container">
      <h2 className="page-heading">
        Der Prozess der Wärmeplanung im Überblick
      </h2>
      <img src={WärmePNG} alt="Prozess der Wärmeplanung" />
    </div>
  </section>
);

export default Wärmeplanung;
